import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./plan.css";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Card, Checkbox, Button, Empty } from "antd/lib";
import { message, Skeleton } from "antd/lib";
import {
  selected_quote,
  ShortListQuote,
} from "../../Redux/actions/NumBikeation";
import { HealthQuestions } from "../../Redux/actions/NumHealth";
import {
  QuickQuoteLife,
  ErrQuotesLife,
  SelectedPayTill,
} from "../../Redux/actions/NumLife";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import LifeComparePlan from "./LifeCompare";
import axiosInLife from "../../Redux/axios/AxiosInLife";
import ShorIcon from "../../assets/label_short.png";
import ShortedIcon from "../../assets/label_shortlist.png";
import moment from "moment";

function PlanLife() {
  const history = useHistory();
  const dispatch = useDispatch();
  const LifeNum = useSelector((state) => state?.lifedetail?.lifenum);
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
  const QQuoteErr = useSelector((state) => state?.lifedetail?.errquote);
  const SQQPlanMode = useSelector((state) => state?.common?.selectedLifePlan);
  const ShortLQQ = useSelector((state) => state?.common?.shortlist);
  const LifeQQuotes = useSelector((state) => state?.lifedetail?.quickquotes);
  const Paytill = useSelector((state) => state?.common?.paytillAge);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [skullloading, setSkullloading] = useState(true);
  const [QuoteData, setQuoteData] = useState([]);
  const [CompareQQ, setCompareQQ] = useState([]);
  const [showShriPaln, setShowShriPLan] = useState(false);
  const [coverTill, setCoverTill] = useState("");
  const [payTill, setPayTill] = useState(Paytill ? Paytill : "");
  // console.log("LifeQQuotesssss", LifeQQuotes);
  useEffect(() => {
    dispatch(ErrQuotesLife([]));
    dispatch(HealthQuestions([]));
    fetchData();
    validatePolicyTerm();
  }, [SQQPlanMode, QuotePost, CusDeatail]);

  // console.log("Paytill", Paytill);

  const fetchData = () => {
    const UpdateQQPost = {
      ...QuotePost,
      UserID: "REKAGJGEGH",
      // SumProposed: CusDeatail?.Income,
    };
    setSkullloading(true);
    setLoading(true);
    // const array = [...QQuoteData];
    axiosInLife
      .post(
        `v1/life_insurances/${LifeNum?.insurance_id}/quick_quotes`,
        UpdateQQPost
      )
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          const data = res?.data?.data;
          console.log("dataaaaaa", data);
          // console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item?.status === "failed"
          );
          //dispatch(ErrQuotesLife(errData));

          // const Breakin = data?.filter(item => ("motorBreakIn" in item && item?.motorBreakIn.isBreakin === true));
          // console.log('Breakin',Breakin)

          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );

          const updatedData = filteredData?.map((item) => ({
            ...item,
            responses: item.responses.map((response) => ({
              ...response,
              ...response[SQQPlanMode],
              insurer: item.insurer,
              logo: item.logo,
            })),
          }));
          console.log("updatedDataaaa", updatedData);
          // const combinedData = array.concat(updatedData);
          // console.log('combine', combinedData);

          // QQuoteData = combinedData;
          // const filteredQuotes = updatedData?.filter(
          //   (quote) => quote[SQQPlanMode] != null
          // );
          // const result = data[0]?.responses?.map((quote) => {
          //   const selectedQuote = quote[SQQPlanMode];
          //   const insurer = quote.insurer;
          //   const selected = quote.selected;
          //   const compare = quote.compare;
          //   return {
          //     ...selectedQuote,
          //     insurer,
          //     selected,
          //     compare,
          //   };
          // });
          // console.log("result", result);
          setQuoteData(updatedData);
          dispatch(QuickQuoteLife(updatedData));
          setSkullloading(false);
          setLoading(false);
        } else {
          setSkullloading(false);
          setLoading(false);
          //console.log(res);
          message.error(res.data.error.validationMessages.join(","));
        }
      })
      .catch((err) => {
        console.log(err.response?.data);
        setSkullloading(false);
        setLoading(false);
        if (err?.response?.data?.message == "Unauthenticated.") {
          message.error(err?.response?.data?.message);
          dispatch((dispatch) => {
            dispatch({ type: "RESET_UAT" });
          });
          history.push("/");
        }
      });
  };
  const validatePolicyTerm = () => {
    const PTerm = parseInt(CusDeatail?.PolicyTerm);
    const age = parseInt(CusDeatail?.Age);
    const selectedAgeGap = PTerm + age;
    setCoverTill(selectedAgeGap);
    const PremTerm = parseInt(QuotePost?.PremiumTerm);
    const Premage = parseInt(CusDeatail?.Age);
    const selectedPremAgeGap = PremTerm + Premage;
    setPayTill(selectedPremAgeGap);
    dispatch(SelectedPayTill(selectedPremAgeGap));
  };

  const handlePlan = (quote) => {
    console.log("click quote", quote);
    if (quote?.insurer === "shri_ram") {
      setLoading(true);
      const dob = moment(CusDeatail?.dateofbirth).format("DD-MM-YYYY");
      console.log(dob);
      const post = {
        PartnerID: "YYBXXX",
        InvestFor: "S",
        Name: CusDeatail?.Name,
        DateOfBirth: dob,
        PlanID: quote?.PlanNo,
        Gender: CusDeatail?.gender,
        EmailID: CusDeatail?.Email,
        MobileNumber: CusDeatail?.Mobile,
        PreferredLanguage: "ENGLISH",
        PolicyTerm: QuotePost?.PolicyTerm,
        PremiumTerm: QuotePost?.PremiumTerm,
        PaymentFrequency: QuotePost?.PremiumPaymentFrequency,
        SumAssured: quote?.SumAssured,
        LifeCover: quote?.SumAssured,
        PremiumAmount: quote?.TotalPrem,
        BasicPremium: quote?.BasicST,
        BasicST: "0",
        ExtraPremium: "0",
        ExtraST: "0",
        InvestmentAmount: quote?.BasicPremium,
      };
      axiosInLife
        .post(
          `v1/life_insurances/${LifeNum?.insurance_id}/insurers/${quote?.insurer}/create_lead`,
          post
        )
        .then((res) => {
          dispatch(selected_quote(quote));
          const ResData = res?.data?.data;
          console.log(ResData);
          const URL = ResData?.Url;
          setLoading(false);
          if (ResData?.status === "success") {
            window.open(URL, "_blank");
          }
        })
        .catch((err) => {
          console.log(err?.response);
          setLoading(false);
        });
    } else {
      setLoading(false);
      dispatch(selected_quote(quote));
      history.push("/CustomerHealth");
    }
  };
  // const showOtherPlan =()=>{
  //   setShowShriPLan(true)
  // }
  const handleCheckboxChange = (index) => {
    const updatedData = LifeQQuotes?.map((item) => ({
      ...item,
      responses: item?.responses?.map((response, i) => {
        if (i === index) {
          return { ...response, compare: !response.compare };
        }
        return response;
      }),
    }));
    // console.log("updatedDataaaaa", updatedData);
    // const updatedQQuoteData = LifeQQuotes?.map((quote, i) => {
    //   console.log('handleCheckboxChange',quote, i)
    //   if (i === index) {
    //     return { ...quote, compare: !quote.compare };
    //   }
    //   return quote;
    // });
    const trueObjects = updatedData?.map((quote) =>
      quote?.responses?.filter((tb) => tb.compare)
    );
    const FlatArry = trueObjects.flat();
    // console.log("trueObjectsssss", FlatArry);
    setCompareQQ(FlatArry);
    setQuoteData(updatedData);
    dispatch(QuickQuoteLife(updatedData));
  };

  const onShortList = (index) => {
    const updatedData = LifeQQuotes?.map((item) => ({
      ...item,
      responses: item.responses.map((response, i) => {
        if (i === index) {
          return { ...response, selected: !response.selected };
        }
        return response;
      }),
    }));
    // const updatedQQuoteData = LifeQQuotes?.map((quote, i) => {
    //   if (i === index) {
    //     return { ...quote, selected: !quote.selected };
    //   }
    //   return quote;
    // });
    // console.log("updatedDataaaaaa", updatedData);
    const trueObjects = updatedData?.map((quote) =>
      quote?.responses?.filter((tb) => tb.selected)
    );
    const FlatArry = trueObjects.flat();
    // console.log("trueObjectsssss", FlatArry);
    setQuoteData(updatedData);
    dispatch(QuickQuoteLife(updatedData));
    dispatch(ShortListQuote(FlatArry));
  };
  const onClearList = () => {
    const updatedData = ShortLQQ?.map((item) => ({
      ...item,
      selected: false,
    }));
    dispatch(ShortListQuote([]));
    dispatch(QuickQuoteLife(updatedData));
    setQuoteData(updatedData);
  };
  // const handleOpen = (quote) => {
  //   //console.log(quote)
  //   setPremiumData(quote);
  //   setShow(true);
  // };
  // const onGstChange = (checked) => {
  //   console.log(checked);
  //   const updatedData = LifeQQuotes?.map((item) => ({
  //     ...item,
  //     IsGst: checked,
  //   }));
  //   console.log(updatedData);
  //   dispatch(QuickQuoteLife(updatedData));
  // };
  return (
    <>
      <div className="hl-found-life">
        <div className="hl-inner">
          <div className="plan-card-head row align-items-center">
            {!skullloading && LifeQQuotes ? (
              <div className="quotelength-life">
                <p className="mb-0">
                  <span className="life-qq-length">
                    {LifeQQuotes?.length === 1
                      ? "One"
                      : LifeQQuotes?.length === 2
                      ? "Two"
                      : LifeQQuotes?.length === 3
                      ? "Three"
                      : "No"}{" "}
                  </span>
                  Quote{LifeQQuotes?.length > 1 ? "s" : null} Found
                </p>
              </div>
            ) : (
              ""
            )}
            {/* </div> */}
          </div>
        </div>
      </div>

      <div className="d-flex row">
        <div className="planhealth-flex col">
          {skullloading && LifeQQuotes?.length === 0 ? (
            <Card className="plan-card ">
              <Skeleton
                active
                loading={skullloading}
                paragraph={{ rows: 4 }}
              ></Skeleton>
            </Card>
          ) : null}

          {!skullloading && LifeQQuotes?.length === 0 ? (
            <div style={{ padding: "30px" }}>
              <Empty description="No Quotes Found" />
            </div>
          ) : (
            <>
              {LifeQQuotes?.map((quotes, i) => (
                <>
                  {/* {console.log('quote, index',quotes, i)} */}
                  {quotes?.responses &&
                    quotes?.responses?.map((quote, index) => (
                      <>
                        {/* {console.log('quote, index',quote, index)} */}
                        <div className="card-container" key={`${i}-${index}`}>
                          {index === 0 && (
                            <Card key={index} className="plan-card-life">
                              <Skeleton
                                active
                                loading={skullloading}
                                paragraph={{ rows: 4 }}
                              >
                                <>
                                  <div className="plan-lfr-sec row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex px-0">
                                      <div className="shorlist-button">
                                        {quote.selected ? (
                                          <img
                                            src={ShortedIcon}
                                            onClick={() => onShortList(index)}
                                          />
                                        ) : (
                                          <img
                                            src={ShorIcon}
                                            onClick={() => onShortList(index)}
                                          />
                                        )}
                                      </div>
                                      <div className="hp-logo-sec-life">
                                        <div className="">
                                          <img
                                            className="qq-ins-logo"
                                            src={quote?.logo}
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                      <div className="hp-logo-sec-life">
                                        <div className="life-plan">
                                          {quote?.PlanNo === "127"
                                            ? "Shriram Life Early Cash Plan"
                                            : quote?.PlanNo === "139"
                                            ? "Shriram Life Premier Assured Benefit"
                                            : null}
                                          {/* <p>₹{quote?.SumAssured}</p> */}
                                        </div>
                                        <div className="life-cover">
                                          Life Cover :
                                          <span> ₹{quote?.SumAssured}</span>
                                        </div>
                                      </div>
                                    </div>
                                    {quote?.ResponseMsg === "Success" ? (
                                      <>
                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-flex px-0">
                                          <div className="hp-logo-sec-life text-center">
                                            <div className="life-plan-cover">
                                              Coverage till
                                            </div>
                                            <div className="life-cover-yr">
                                              {coverTill} Yrs
                                            </div>
                                          </div>
                                          <div className="hp-logo-sec-life text-center">
                                            <div className="life-plan-cover">
                                              Pay till
                                            </div>
                                            <div className="life-cover-yr">
                                              {Paytill} Yrs
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-flex">
                                          <div className="hp-logo-sec-life">
                                            <div className="text-center">
                                              <Button
                                                loading={loading}
                                                className="gross-txt-life"
                                                onClick={() =>
                                                  handlePlan(quote)
                                                }
                                              >
                                                {quote?.IsGst === true ? (
                                                  <>
                                                    ₹{" "}
                                                    {typeof quote?.TotalPrem ===
                                                    "string"
                                                      ? Math.round(
                                                          parseFloat(
                                                            quote?.TotalPrem.replace(
                                                              /[^\d.]/g,
                                                              ""
                                                            )
                                                          )
                                                        )
                                                      : quote?.TotalPrem}
                                                    <p
                                                      className="mb-0"
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      (Including GST)
                                                    </p>
                                                  </>
                                                ) : (
                                                  <>
                                                    <>{SQQPlanMode}</>
                                                    <br />₹{" "}
                                                    {typeof quote?.TotalPrem ===
                                                    "string"
                                                      ? Math.round(
                                                          parseFloat(
                                                            quote?.TotalPrem.replace(
                                                              /[^\d.]/g,
                                                              ""
                                                            )
                                                          )
                                                        )
                                                      : quote?.TotalPrem}
                                                  </>
                                                )}
                                              </Button>
                                            </div>
                                            {showShriPaln === false ? (
                                              <div
                                                onClick={() =>
                                                  setShowShriPLan(!showShriPaln)
                                                }
                                                className="text-center more-plan"
                                              >
                                                +{" "}
                                                {quotes?.responses?.length - 1}{" "}
                                                more plan
                                                <span className="d-flex">
                                                  <DownOutlined />
                                                </span>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>{" "}
                                      </>
                                    ) : (
                                      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                                        <p className="mb-0 text-danger">
                                          {quote?.ResponseMsg}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                  <div className="hp-logo-sec-life">
                                    {/* <p
                                className="mb-0 d-flex"
                              >
                                Add ons{" "}
                                <span className="double-right">
                                  <DoubleRightOutlined />
                                </span>
                              </p> */}
                                    <div
                                    // className="hp-logo-sec-life text-center"
                                    >
                                      <div>
                                        <Checkbox
                                          checked={quote?.compare}
                                          onChange={() =>
                                            handleCheckboxChange(index)
                                          }
                                        >
                                          Add to Compare
                                        </Checkbox>
                                      </div>
                                    </div>
                                  </div>
                                  {/* {quote?.motorBreakIn?.isBreakin === true ? <p className="text-center text-danger">*Breakin Policy is under develop</p> : null}            */}
                                </>
                              </Skeleton>
                            </Card>
                          )}
                          {showShriPaln && index === 1 && (
                            <>
                              <Card
                                key={index}
                                className={`plan-card-life ${
                                  showShriPaln ? "card-flip" : ""
                                }`}
                              >
                                <Skeleton
                                  active
                                  loading={skullloading}
                                  paragraph={{ rows: 4 }}
                                >
                                  <>
                                    <div className="plan-lfr-sec row">
                                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex px-0">
                                        <div className="shorlist-button">
                                          {quote.selected ? (
                                            <img
                                              src={ShortedIcon}
                                              onClick={() => onShortList(index)}
                                            />
                                          ) : (
                                            <img
                                              src={ShorIcon}
                                              onClick={() => onShortList(index)}
                                            />
                                          )}
                                        </div>
                                        <div className="hp-logo-sec-life">
                                          <div className="">
                                            <img
                                              className="qq-ins-logo"
                                              src={quote?.logo}
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                        <div className="hp-logo-sec-life">
                                          <div className="life-plan">
                                            {quote?.PlanNo === "127"
                                              ? "Shriram Life Early Cash Plan"
                                              : quote?.PlanNo === "139"
                                              ? "Shriram Life Premier Assured Benefit"
                                              : null}
                                          </div>
                                          {quote?.ResponseMsg === "Success" ? (
                                            <div className="life-cover">
                                              Life Cover :
                                              <span> ₹{quote?.SumAssured}</span>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                      {quote?.ResponseMsg === "Success" ? (
                                        <>
                                          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-flex px-0">
                                            <div className="hp-logo-sec-life text-center">
                                              <div className="life-plan-cover">
                                                Coverage till
                                                {/* <p>₹{quote?.SumAssured}</p> */}
                                              </div>
                                              <div className="life-cover-yr">
                                                {coverTill} Yrs
                                              </div>
                                            </div>
                                            <div className="hp-logo-sec-life text-center">
                                              <div className="life-plan-cover">
                                                Pay till
                                                {/* <p>₹{quote?.SumAssured}</p> */}
                                              </div>
                                              <div className="life-cover-yr">
                                                {Paytill} Yrs
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 d-flex">
                                            <div className="hp-logo-sec-life">
                                              <div className="text-center">
                                                <Button
                                                  loading={loading}
                                                  className="gross-txt-life"
                                                  onClick={() =>
                                                    handlePlan(quote)
                                                  }
                                                >
                                                  {quote?.IsGst === true ? (
                                                    <>
                                                      ₹{" "}
                                                      {typeof quote?.TotalPrem ===
                                                      "string"
                                                        ? Math.round(
                                                            parseFloat(
                                                              quote?.TotalPrem.replace(
                                                                /[^\d.]/g,
                                                                ""
                                                              )
                                                            )
                                                          )
                                                        : quote?.TotalPrem}
                                                      <p
                                                        className="mb-0"
                                                        style={{
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        (Including GST)
                                                      </p>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <>{SQQPlanMode}</>
                                                      <br />₹{" "}
                                                      {typeof quote?.TotalPrem ===
                                                      "string"
                                                        ? Math.round(
                                                            parseFloat(
                                                              quote?.TotalPrem.replace(
                                                                /[^\d.]/g,
                                                                ""
                                                              )
                                                            )
                                                          )
                                                        : quote?.TotalPrem}
                                                    </>
                                                  )}
                                                </Button>
                                              </div>
                                              {/* <div 
                                onClick={showOtherPlan}
                                className="text-center more-plan">
                                + {LifeQQuotes?.length}
                                  more plan
                                  </div> */}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                                          <p className="mb-0 text-danger">
                                            {quote?.ResponseMsg}
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="hp-logo-sec-life">
                                      <div>
                                        <Checkbox
                                          checked={quote?.compare}
                                          onChange={() =>
                                            handleCheckboxChange(index)
                                          }
                                        >
                                          Add to Compare
                                        </Checkbox>
                                      </div>
                                    </div>
                                    {/* {quote?.motorBreakIn?.isBreakin === true ? <p className="text-center text-danger">*Breakin Policy is under develop</p> : null}            */}
                                  </>
                                </Skeleton>
                              </Card>
                              {showShriPaln === true ? (
                                <div
                                  onClick={() => setShowShriPLan(!showShriPaln)}
                                  className="text-center less-plan"
                                >
                                  Show Less
                                  <span className="d-flex">
                                    <UpOutlined />
                                  </span>
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                      </>
                    ))}
                </>
              ))}
            </>
          )}
        </div>
        <div className="health-shortlist col img-0">
          <div className="shortlist-inner">
            <div className="head-short">
              Shortlisted Plan(s)
              <span>
                {LifeQQuotes &&
                  LifeQQuotes?.some((quote) => quote.selected) &&
                  ShortLQQ?.length}
              </span>
            </div>
            {ShortLQQ && ShortLQQ?.some((quote) => quote.selected) ? null : (
              <p className="mt-2">
                Use{" "}
                <img
                  src={ShorIcon}
                  style={{ width: "20px" }}
                  alt="Shortlist icon"
                />{" "}
                to Shortlist Plans
              </p>
            )}
            {ShortLQQ?.map((quote, index) => (
              <div key={index}>
                {quote?.selected === true && index === 0 && (
                  <div className="py-2">
                    <div className="d-flex gap-4">
                      <div className="shortlist-img">
                        <img src={quote?.logo}></img>
                      </div>
                      <div className="shorlisted-text">
                        <p>
                          {quote?.insurer === "shri_ram"
                            ? "ShriRam Life Insurance"
                            : null}
                        </p>
                        <div className="d-flex justify-content-between">
                          <div>
                            <span>Cover</span>
                            <p> {quote?.SumAssured}</p>
                          </div>
                          <div>
                            <span>Premium</span>
                            <p>
                              ₹{" "}
                              {typeof quote?.TotalPrem === "string"
                                ? Math.round(
                                    parseFloat(
                                      quote?.TotalPrem.replace(/[^\d.]/g, "")
                                    )
                                  )
                                : quote?.TotalPrem}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Button type="primary" onClick={onClearList}>
                        Clear
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          size="lg"
        >
          {/* <PremiumbreakupHealth quickQuote={PremiumData}/> */}
        </Modal>
      </div>

      <div className="d-flex mt-3 justify-content-center">
        <div
          className={`${
            QQuoteErr?.length > 0
              ? `bg-light errQ mt-3 px-3 py-3 col-xl-10 col-lg-12 col-md-12 col-sm-12`
              : `mt-3 px-3 py-3 col-xl-10 col-lg-12 col-md-12 col-sm-12`
          } `}
        >
          {!skullloading && (
            <>
              {QQuoteErr?.length > 0 && (
                <p className="err-q-txt">
                  *We are not getting quote(s) from the following insurers. It
                  might be possible reasons at the insurance company's end like
                  MMV or RTO restricted or might be some technical issue.
                </p>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                {QQuoteErr?.map((quote, index) => (
                  <div
                    key={index}
                    className="bg-white p-2 text-center col-xl-2"
                  >
                    <div className="qq-err-txt">
                      <img
                        style={{ width: "100px" }}
                        src={quote?.logo}
                        alt=""
                      />
                      <p>{quote?.message}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      {CompareQQ?.length > 0 ? (
        <LifeComparePlan
          compareQQ={CompareQQ}
          setCompareQQ={setCompareQQ}
          LifeQQuotes={LifeQQuotes}
          setQuoteData={setQuoteData}
        />
      ) : null}
    </>
  );
}

export { PlanLife };
